//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime, formatDate } from '../../components/helpers.js'
import { axiosGet } from '../../axios/axios.js'
import Table from '../../components/Table/Table.vue'

export default {
  components: {
    Table
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      brigade: null,
      loading: false,
      formatDate: formatDate,
      columns: [
        {
          name: 'objectAlias',
          label: 'Объект обслуживания',
          align: 'center',
          field: 'objectAlias',
          sortable: true
        },
        {
          name: 'name',
          label: 'Заявка',
          align: 'center',
          field: 'name',
          sortable: true
        },
        {
          name: 'departureReportId',
          label: 'Отчёт',
          align: 'center',
          field: 'departureReportId',
          format: this.formatDeparture,
          sortable: true
        },
        {
          name: 'type',
          label: 'Тип заявки',
          align: 'center',
          field: 'type',
          sortable: true
        },
        {
          name: 'startTime',
          label: 'Дата/время начала работ',
          field: 'startTime',
          align: 'left',
          format: convertTime
        },
        {
          name: 'endTime',
          label: 'Дата/время завершения работ',
          field: 'endTime',
          format: convertTime,
          align: 'left'
        }
      ]
    }
  },
  created: function () {
    this.loadBrigadePerformedTasks()
  },
  methods: {
    convertTime: convertTime,
    formatDeparture: function (departureReportId, task) {
      return task && task.reports && task.reports.length > 0 && task.reports.find(report => report.id == departureReportId) && task.reports.find(report => report.id == departureReportId).name
    },
    isCurrentReport: function (task) {
      return this.report.id === task.departureReportId
    },
    openReport: function (event, task) {
      // router не реагирует на изменение только documentId, поэтому жесткое открытие ссылки
      event.preventDefault()
      window.location.href = '/task/' + task.id + (task.departureReportId ? '/document/' + task.departureReportId : '')
    },
    loadBrigadePerformedTasks: function (row) {
      this.loading = true
      const urlParams = new URLSearchParams()

      urlParams.append('id', this.report.brigadeId)
      if (this.report.creationTime) {
        urlParams.append('date', this.report.creationTime)
        urlParams.append('currentWorkShift', false)
      } else {
        urlParams.append('currentWorkShift', true)
      }

      return axiosGet({
        url: 'service/delta/brigade/get?' + urlParams.toString(),
        onSuccess: (response) => {
          this.brigade = response && response.data
        },
        onFailure: 'Ошибка загрузки'
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

